<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card dashboard-card statistics-card">
        <div class="row">
          <div
              v-for="record in Statistics"
              :key="record.id"
              class="col-xl-3 col-lg-6 col-md-6 d-flex"
          >
            <div class="statistics-grid flex-fill">
              <div class="statistics-content">
                <h3>{{ record.Amount }}</h3>
                <p>{{ record.Content }}</p>
              </div>
              <div class="statistics-icon">
                <img :src="require(`@/assets/img/icons/${record.Image}`)" alt="Icon"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, ref, watch, watchEffect} from 'vue';
import {useQuery} from '@vue/apollo-composable';
import {GET_TOUR_MATCHES_BY_PLAYER} from '@/graphql/operations/tour-match.ts';
import {GET_CATEGORY_RANKS} from "@/graphql/operations/tournament-rank.ts";
import {GET_TOURNAMENT_BY_PLAYER} from "@/graphql/operations/tournament.ts";

const countTour = ref(0);
const countMatch = ref(0);
const countPoint = ref(0);
const countWin = ref(0);

const player = JSON.parse(localStorage.getItem('player'));
const playerId = player?.documentId ?? '';

const {result: resultTournament} = useQuery(GET_TOURNAMENT_BY_PLAYER, () => ({
      documentId: playerId,
      page: 1,
      pageSize: 1,
      keyword: "",
    }),
    {fetchPolicy: 'network-only'},
);

watch(
    resultTournament,
    () => {
      if (resultTournament.value?.tournaments_connection) {
        countTour.value = resultTournament.value.tournaments_connection.pageInfo.total;
      } else {
        countTour.value = 0;
      }
    },
    {deep: true}
);

const {result: resultTourMatch} = useQuery(
    GET_TOUR_MATCHES_BY_PLAYER,
    () => ({
      player: playerId,
      page: 1,
      pageSize: 1,
      keyword: '',
    }),
    {fetchPolicy: 'network-only'}
);

watch(
    resultTourMatch,
    () => {
      if (resultTourMatch.value?.tourMatches_connection) {
        countMatch.value = resultTourMatch.value.tourMatches_connection.pageInfo.total;
      } else {
        countMatch.value = 0;
      }
    },
    {deep: true}
);

const pagination = ref({
  current: 1,
  pageSize: 1,
  total: 0,
  showSizeChanger: true,
});

const paginationOptions = computed(() => ({
  page: Number(pagination.value.current),
  pageSize: Number(pagination.value.pageSize),
}));
const sortOptions = ['rank:asc'];

const filtersCategoryRank = computed(() => ({
  tour_player_team: {
    or: [
      {
        player_1: {
          documentId: {
            eq: playerId,
          },
        },
      },
      {
        player_2: {
          documentId: {
            eq: playerId,
          },
        },
      },
    ],
  },
}));


const {result: categoryRank} = useQuery(
    GET_CATEGORY_RANKS,
    {filters: filtersCategoryRank, pagination: paginationOptions, sort: sortOptions}
);

watchEffect(() => {
  const arr = categoryRank.value?.categoryRanks || [];

  countPoint.value = 0;
  countWin.value = 0;

  let num = 99999;

  for (let i = 0; i < arr.length; i++) {
    countPoint.value += arr[i].point;

    const rank = arr[i].rank;
    if (rank < num) {
      num = rank;
    }
  }

  countWin.value = num === 99999 ? 0 : num;
  if (countWin.value !== 0) {
    countWin.value = '#' + countWin.value;
  }
});

const Statistics = [
  {
    Image: 'statistics-01.svg',
    Amount: countTour,
    Content: 'Giải đấu',
  },
  {
    Image: 'statistics-02.svg',
    Amount: countMatch,
    Content: 'Trận đấu',
  },
  {
    Image: 'icon_rank.svg',
    Amount: countWin,
    Content: 'Hạng cao nhất',
  },
  {
    Image: 'statistics-03.svg',
    Amount: countPoint,
    Content: 'Điểm',
  },
];
</script>

